(() => {
  const script = document.currentScript;
  const config = {
    active: script?.dataset.batmanDayActive !== 'false',
    variantId: Number(script?.dataset.batmanDayVariantId || 52837944328324),
  };
  if (!config?.variantId || !config.active) return;

  let syncing = false;
  let rerun = false;
  let promotionIsFree;
  const nativeFetch = window.fetch.bind(window);
  const excludedVariantIds = new Set([52833468285060]);

  const isEligible = (item) =>
    Number(item.variant_id) !== Number(config.variantId) &&
    !excludedVariantIds.has(Number(item.variant_id)) &&
    item.properties?._bb_batman_day_excluded !== 'true' &&
    (item.product_type === 'In-Stock Comics' ||
      item.product_type === 'Dollar Bin & Value Comics' ||
      item.properties?._bb_in_stock_comic === 'true');

  async function request(url, options) {
    const response = await nativeFetch(url, options);
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }

  async function sync() {
    if (syncing) {
      rerun = true;
      return;
    }
    syncing = true;
    try {
      if (promotionIsFree === undefined) {
        const productResponse = await nativeFetch('/products/batman-of-two-worlds-1-batman-day-2026.js', { headers: { Accept: 'application/json' } });
        const product = await productResponse.json();
        const giftVariant = product.variants?.find((variant) => Number(variant.id) === Number(config.variantId));
        promotionIsFree = Boolean(productResponse.ok && giftVariant?.available && Number(giftVariant.price) === 0);
      }
      if (!promotionIsFree) return;
      const cart = await request(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const gift = cart.items.find((item) => Number(item.variant_id) === Number(config.variantId));
      const qualifies = cart.items.some(isEligible);
      let updated = null;

      if (qualifies && !gift) {
        updated = await request(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: config.variantId, quantity: 1, properties: { _bb_batman_day_gift: 'true' } }] }),
        });
      } else if (gift && (!qualifies || gift.quantity !== 1)) {
        updated = await request(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: qualifies ? 1 : 0 }),
        });
      }

      if (updated && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'batman-day-gift', cartData: updated });
      }
    } catch (error) {
      console.warn('Batman Day gift could not be synchronized.', error);
    } finally {
      syncing = false;
      if (rerun) {
        rerun = false;
        sync();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', sync);
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const url = String(args[0]?.url || args[0] || '');
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
      window.setTimeout(sync, 0);
    }
    return response;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'batman-day-gift') sync();
    });
  }
})();
